// extracted by mini-css-extract-plugin
module.exports = {"root":"Qs-Ik","OverlineMenuButtonNSkin":"_3K028","overlineMenuButtonNSkin":"_3K028","linkElement":"_11ip9","gapper":"_30m7F","wrapper":"_3ATbA","label":"_3O9tb"};